module.exports = __webpack_public_path__ + "img/9.b3140b42.jpg";